import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Pagination } from '@interfaces/pagination';

@Component({
    selector: 'app-server-paginator',
    templateUrl: './server-paginator.component.html',
    styleUrls: ['./server-paginator.component.scss']
})
export class ServerPaginatorComponent {
    @Input() pagination: Pagination;
    @Input() isDisabled: boolean;
    @Output() paginationChange = new EventEmitter<PageEvent>();

    constructor() { }

    onPagechange(event: PageEvent): void {
        this.paginationChange.emit(event);
    }

}
